import { NgClass } from '@angular/common';
import { Component, Input, inject } from '@angular/core';

import { EnvironmentConfig } from '../../../client-config/index';
import { LocaleDirective } from '../../directives/locale.directive';

@Component({
    selector: 'no-events',
    templateUrl: './no-events.component.html',
    styleUrls: ['./no-events.component.scss'],
    imports: [LocaleDirective, NgClass],
})
export class NoEventsComponent {
    @Input() message: string = 'app.noEventsFound';
    @Input() eventQuickSwitch: boolean = false;
    private readonly environment = inject(EnvironmentConfig).configuration;
    isCoral: boolean = this.environment.BRAND === 'bma';
}
